module.exports = __webpack_public_path__ + "img/news-image9.fd8332ab.png";